import { FC, isValidElement, PropsWithChildren } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Popconfirm } from './Popconfirm';
import translations from './PopconfirmDelete.translations.json';
import { TextDisabled } from './typography/TextDisabled';
import { DropdownItem } from './DropdownItem';

const { addTranslations, useTranslation } = i18nNsFactory('popconfirm-delete');
addTranslations(translations);

type PopconfirmDeleteContentProps =
  | {
      genitiveModelName: string;
      description?: never;
    }
  | {
      genitiveModelName?: never;
      description: string;
    };

export type PopconfirmDeleteProps = {
  onDelete: () => void;
  disabled?: boolean;
  stopClickPropagation?: boolean;
} & PopconfirmDeleteContentProps;

export const PopconfirmDelete: FC<PropsWithChildren<PopconfirmDeleteProps>> = (
  props,
) => {
  const {
    onDelete,
    description,
    disabled,
    genitiveModelName,
    children,
    stopClickPropagation,
    ...rest
  } = props;
  const { t } = useTranslation();
  if (disabled) {
    return <TextDisabled>{children || t('label')}</TextDisabled>;
  }
  return (
    <Popconfirm
      id="delete-popconfirm"
      onConfirm={onDelete}
      title={t('label')}
      description={description || t('description', { genitiveModelName })}
      okText={t('confirm')}
      cancelText={t('decline')}
      placement="auto"
      stopClickPropagation={stopClickPropagation}
      {...rest}
    >
      {isValidElement(children) ? (
        children
      ) : (
        <DropdownItem>{children || t('label')}</DropdownItem>
      )}
    </Popconfirm>
  );
};
